import { ContactCard, ContactAvatar, TContactCardTheme } from '@cian/contact-card-component';
import { UiKitContextProvider } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AgencyBrandingAsideCard.css';

interface IAgencyCard {
  agencyAvatar: string | null;
  onAgencyNameClick(): void;
  agencyName: string;
  agencyLink: string;
  agencyIconsElement: React.ReactNode;
  agencyLabels: React.ReactNode;
  agencyFeaturesElement: React.ReactNode;
  agentElement: React.ReactNode;
  theme: TContactCardTheme;
  mortgage?: React.ReactNode;
}

const AgencyBrandingAsideCardComponent: React.FC<IAgencyCard> = ({
  agencyAvatar,
  onAgencyNameClick,
  agencyName,
  agencyLink,
  agencyIconsElement,
  agencyLabels,
  agencyFeaturesElement,
  agentElement,
  theme,
  mortgage,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['body']}>
        <UiKitContextProvider useStaticDeviceType deviceType="desktop">
          <ContactCard
            title="Агентство недвижимости"
            onNameClick={onAgencyNameClick}
            avatar={<ContactAvatar type="agency" src={agencyAvatar} />}
            name={agencyName}
            href={agencyLink}
            nameIcons={agencyIconsElement}
            labels={agencyLabels}
            features={agencyFeaturesElement}
            subcontact={agentElement}
            theme={theme}
          />
        </UiKitContextProvider>
      </div>
      {mortgage && <div className={styles['mortgage']}>{mortgage}</div>}
    </div>
  );
};

export const AgencyBrandingAsideCard = React.memo(AgencyBrandingAsideCardComponent);
